import React from "react";

import classnames from "classnames";
import { isBrowser } from "../../../core/detection";
import { api } from "../../../shared/api/system/apiClient";

import "./hubspotForm.scss";

interface State {
  subscriptionSending: boolean;
  subscriptionSent: boolean;
  subscriptionErrored: boolean;
  subscriptionMessage?: string;
}

export class HubspotNewsletterSignupForm extends React.Component<{}, State> {
  private inputRef: HTMLInputElement;

  constructor(props) {
    super(props);
    this.state = {
      subscriptionSending: false,
      subscriptionSent: false,
      subscriptionErrored: false,
    };
  }

  public componentDidUpdate() {
    // Hides sucess message after 8 seconds
    if (this.state.subscriptionSent) {
      setTimeout(() => this.setState({ subscriptionSent: false }), 8000);
    }
  }

  /**
   * Returns a generic error message by default.
   * Returns a email specific message, if there is a email related validation error.
   */
  private parseError(validations: IValidationError[]): string {
    let subscriptionErrorMessage = "There was a problem with sending your form. Please try again.";
    if (validations && validations.length > 0) {
      if (validations.some(e => e.attribute === "emailAddress")) {
        subscriptionErrorMessage = "Please provide a valid email address.";
      }
    }
    return subscriptionErrorMessage;
  }

  private getPageData(): Pick<IHubspotNewsletterSubscription, "pageUri" | "pageName"> {
    if (!isBrowser()) {
      return;
    }
    return {
      pageUri: window.location.href || "N/A",
      pageName: document.title || "N/A",
    };
  }

  private subscribe = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const pageData: Pick<IHubspotNewsletterSubscription, "pageUri" | "pageName"> = this.getPageData();

    // If previously sent, set "sent" flag back to false
    this.setState({ subscriptionSending: true, subscriptionSent: false });
    const postData = {
      emailAddress: this.inputRef.value.trim(),
      ...pageData,
    } as IHubspotNewsletterSubscription;

    try {
      await api.sendNewsletterSubscription(postData);
      const subscriptionMessage = "Thanks for subscribing!";
      this.setState({
        subscriptionSent: true,
        subscriptionErrored: false,
        subscriptionMessage,
        subscriptionSending: false,
      }, () => {
        this.inputRef.value = "";
      });
    } catch (error) {
      const subscriptionMessage = this.parseError(error.validations);
      this.setState({ subscriptionErrored: true, subscriptionMessage, subscriptionSending: false });
    }
  }

  public render() {
    const buttonText = this.state.subscriptionSending ? "Sending" : "Subscribe";
    const validationBarClass = classnames("validation-bar", { success: this.state.subscriptionSent });
    return (
      <div className="hspot-newsletter-form">
        <form
          method="post"
          onSubmit={this.subscribe}
          id=""
          name="hubspot-form"
          className="validate"
          target="_blank" noValidate
        >
          <input
            type="email"
            name="email"
            className="email"
            id=""
            placeholder="Your email..."
            ref={(x) => this.inputRef = x}
            disabled={this.state.subscriptionSending}
            aria-label="Enter your email address"
          />
          <button type="submit" className="primary-button" disabled={this.state.subscriptionSending}>
            {buttonText}
          </button>
        </form>

        {(this.state.subscriptionErrored || this.state.subscriptionSent) &&
          <div className={validationBarClass} key={Math.random()}>{this.state.subscriptionMessage}</div>
        }
      </div>
    );
  }
}
